import { AlertDialog, Text, Button as BackyardButton } from '@backyard-ui/core'
import DOMPurify from 'dompurify'
import { memo } from 'react'

const sanitizeMessage = (dirty: string): string =>
  DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['strong', 'br', 'a', 'u'],
    ALLOWED_ATTR: ['href', 'target', 'rel']
  })

type Option = {
  key: string | number
  label: string
}

type ButtonProps = {
  data: Option
  onClick: (id: string | number) => void
  isDisabled?: boolean
  confirmOnActionMessage?: string
}

const Button = (props: Readonly<ButtonProps>) => {
  const { data, onClick, isDisabled = false, confirmOnActionMessage } = props

  if (confirmOnActionMessage) {
    return (
      <AlertDialog.Root size="2xl">
        <AlertDialog.Trigger asChild>
          <BackyardButton size="xs" variant="subtle" radius="lg">
            {data.label}
          </BackyardButton>
        </AlertDialog.Trigger>

        <AlertDialog.Content>
          <AlertDialog.Title>{data.label}</AlertDialog.Title>

          <AlertDialog.Description>
            <Text size="md" asChild>
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizeMessage(confirmOnActionMessage)
                }}
              />
            </Text>
          </AlertDialog.Description>

          <AlertDialog.Footer>
            <AlertDialog.Cancel asChild>
              <BackyardButton appearance="neutral" size="sm">
                Cancelar
              </BackyardButton>
            </AlertDialog.Cancel>

            <AlertDialog.Action>
              <BackyardButton size="sm" onClick={() => onClick(data.key)}>
                {data.label}
              </BackyardButton>
            </AlertDialog.Action>
          </AlertDialog.Footer>
        </AlertDialog.Content>
      </AlertDialog.Root>
    )
  }

  return (
    <BackyardButton
      variant="subtle"
      disabled={isDisabled}
      data-testid="chat-button"
      onClick={() => onClick(data.key)}
      size="xs">
      {data.label}
    </BackyardButton>
  )
}

Button.displayName = 'Button'

export default memo(Button)
